import React, { useState, useEffect } from "react";
import { Container, Table, Pagination } from "react-bootstrap";
import {
  FiEdit, FiTrash2, FiPlus, FiHome, FiChevronRight, FiEye,
} from "react-icons/fi";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getStaff, deleteStaff } from "../../store/slices/staff";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function StaffList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const itemsPerPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [search, setSearch] = useState("");

  const fetchStaff = (page = currentPage, keyword = search) => {

    dispatch(
      getStaff({
        page,
        limit: itemsPerPage,
        keyword,
      })
    )
      .unwrap()
      .then((res) => {
        setData(res?.data || []);
        setTotalData(res?.totalDataCount || 0);
      })
      .catch(({ message }) => {
        console.error(message);
        toast.error("Failed to fetch staff list");
        setData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      fetchStaff(currentPage, search);
    }, 400);

    return () => clearTimeout(timer);
  }, [currentPage, search]);

  const editNavigatedata = (id) => {
    navigate(`/institute/edit-staff/${id}`);
  };

  const viewNavigatedata = (id) => {
    navigate(`/institute/staff-details/${id}`);
  };

  // delete Row

  const handleDeleteRow = (id) => {
    if (!id) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this staff?"
    );

    if (!confirmDelete) return;

    console.log("delete btn in stafflist page", id);

    dispatch(deleteStaff(id))
      .unwrap()
      .then(() => {
        toast.success("Staff deleted successfully ");
        fetchStaff();
      })
      .catch((err) => {
        toast.error(err || "Failed to delete ");
      });
  };

  const totalPages = Math.ceil(totalData / itemsPerPage);

  const paginatedData = data;


  const handleExport = () => {
    dispatch(
      getStaff({
        page: 1,
        limit: totalData,
        keyword: search,
      })
    )
      .unwrap()
      .then((res) => {
        const rows = (res.data || []).map((item, index) => ({
          SlNo: index + 1,
          Name: item.name,
          Department: item.dept,
          Mobile: item.mobileNo,
          Email: item.email,
          Username: item.user?.username,
          Gender: item.gender,
        }));

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Staff");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        const file = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });

        saveAs(file, "Employee-List.xlsx");
      });
  };


  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />

            <span className="active">Staff</span>
          </div>
          <div className="d-flex align-items-center gap-2">

            <button
              type="button"
              className="btn-cancel gap-2"
              onClick={handleExport}
            >
              <IoCloudDownloadOutline />
              Export
            </button>

            <Link
              to="/institute/add-staff"
              className="add-btn"
            >
              <FiPlus />
              Add Staff
            </Link>

          </div>

        </div>
      </div>
      <Container fluid>
        <div className="staff-card">
          <div className="d-flex justify-content-end align-items-end mb-3">
            <div className="search-box">
              <input
                type="text"
                className="form-control"
                placeholder="Search by name, username, mobile, email..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="table-responsive">

            <Table className="staff-table align-middle">
              <thead>
                <tr>

                  <th className="text-center">#</th>
                  <th className="text-center">Name</th>
                  <th className="text-center">Department</th>
                  <th className="text-center">Mobile</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Username</th>
                  <th className="text-center">Gender</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>


              <tbody>
                {isLoading ? (
                  Array.from({ length: 8 }).map((_, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <Skeleton width={20} />
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <Skeleton
                            circle
                            width={40}
                            height={40}
                            style={{ marginRight: 10 }}
                          />
                          <Skeleton width={140} />
                        </div>
                      </td>

                      <td className="text-center">
                        <Skeleton width={100} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={110} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={180} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={130} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={70} />
                      </td>

                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Skeleton width={36} height={36} borderRadius={10} />
                          <Skeleton width={36} height={36} borderRadius={10} />
                          <Skeleton width={36} height={36} borderRadius={10} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : paginatedData.length > 0 ? (
                  paginatedData.map((s, i) => (
                    <tr key={s._id}>
                      <td className="text-center">
                        {(currentPage - 1) * itemsPerPage + i + 1}
                      </td>

                      <td className="staff-name">
                        <img src={s.image} alt="" />
                        {s.name}
                      </td>

                      <td className="text-center">{s.dept}</td>
                      <td className="text-center">{s.mobileNo}</td>
                      <td className="text-center">{s.email}</td>
                      <td className="text-center">{s.user?.username}</td>
                      <td className="text-center">{s.gender}</td>

                      <td className="text-center">
                        <button
                          className="edit-btn me-2"
                          onClick={() => viewNavigatedata(s._id)}
                        >
                          <FiEye size={16} />
                        </button>
                        <button
                          className="edit-btn me-2"
                          onClick={() => editNavigatedata(s._id)}
                        >
                          <FiEdit size={16} />
                        </button>
                        <button
                          className="edit-btn"
                          onClick={() => handleDeleteRow(s._id)}
                        >
                          <FiTrash2 style={{ fontSize: 15 }} />
                        </button>

                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center py-4">
                      No staff found.
                    </td>
                  </tr>
                )}
              </tbody>

            </Table>
          </div>
          <div className="d-flex justify-content-end my-3">
            <Pagination className="mb-0">

              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              />

              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;

                // Show first page, last page, and pages around current page
                if (
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                ) {
                  return (
                    <Pagination.Item
                      key={page}
                      active={page === currentPage}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </Pagination.Item>
                  );
                }

                // Left dots
                if (page === currentPage - 2) {
                  return <Pagination.Ellipsis key={`left-${page}`} disabled />;
                }

                // Right dots
                if (page === currentPage + 2) {
                  return <Pagination.Ellipsis key={`right-${page}`} disabled />;
                }

                return null;
              })}

              <Pagination.Next
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage((p) => p + 1)}
              />

            </Pagination>
          </div>
        </div>
      </Container>
    </>
  );
}
